import { apiCall } from './gqlClient';

const GETBOOKEDEVENTS_QUERY = `
  query getBookedEvents($startTime: DateTime, $endTime: DateTime, $email: String, $resourceId: Int, $entityType: String) {
    getBookedEvents(startTime: $startTime, endTime: $endTime, email: $email, resourceId: $resourceId, entityType: $entityType)
    {
      id
			serviceId
			created
			name
			email
			startTime
			endTime
			type
			entityType
			status
			duration
			capacity
			totalCapacity
			classId
			subServiceId
			serviceName
			price
			collaboratorPercentPrice
      ...fragments
    }
  }`;

export const getBookedEventsApiCall = async ({startTime, endTime, email, resourceId, entityType}, fragments = null) => apiCall({ query: GETBOOKEDEVENTS_QUERY, variables: {startTime, endTime, email, resourceId, entityType}, fragments });

const GETBOOKEDEVENTSBYPROVIDERIDFROMADMIN_QUERY = `
  query getBookedEventsByProviderIdFromAdmin($providerId: Int!, $startTime: DateTime, $endTime: DateTime, $email: String, $resourceId: Int, $entityType: String) {
    getBookedEventsByProviderIdFromAdmin(providerId: $providerId, startTime: $startTime, endTime: $endTime, email: $email, resourceId: $resourceId, entityType: $entityType)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getBookedEventsByProviderIdFromAdminApiCall = async ({providerId, startTime, endTime, email, resourceId, entityType}, fragments = null) => apiCall({ query: GETBOOKEDEVENTSBYPROVIDERIDFROMADMIN_QUERY, variables: {providerId, startTime, endTime, email, resourceId, entityType}, fragments });

const GETCALENDAREVENTS_QUERY = `
  query getCalendarEvents($startTime: DateTime, $endTime: DateTime, $resourceId: Int) {
    getCalendarEvents(startTime: $startTime, endTime: $endTime, resourceId: $resourceId)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getCalendarEventsApiCall = async ({startTime, endTime, resourceId}, fragments = null) => apiCall({ query: GETCALENDAREVENTS_QUERY, variables: {startTime, endTime, resourceId}, fragments });

const GETCUSTOMEREVENTS_QUERY = `
  query getCustomerEvents($identifier: String, $startTime: DateTime, $endTime: DateTime, $customerId: Int, $isDeal: Boolean, $sortLatest: Boolean) {
    getCustomerEvents(identifier: $identifier, startTime: $startTime, endTime: $endTime, customerId: $customerId, isDeal: $isDeal, sortLatest: $sortLatest)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const getCustomerEventsApiCall = async ({identifier, startTime, endTime, customerId, isDeal, sortLatest}, fragments = null) => apiCall({ query: GETCUSTOMEREVENTS_QUERY, variables: {identifier, startTime, endTime, customerId, isDeal, sortLatest}, fragments });

const GETCUSTOMEREVENTSFORWEBDEAL_QUERY = `
  query getCustomerEventsForWebDeal($identifier: String, $startTime: DateTime, $endTime: DateTime, $customerId: Int, $isDeal: Boolean, $sortLatest: Boolean) {
    getCustomerEventsForWebDeal(identifier: $identifier, startTime: $startTime, endTime: $endTime, customerId: $customerId, isDeal: $isDeal, sortLatest: $sortLatest)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const getCustomerEventsForWebDealApiCall = async ({identifier, startTime, endTime, customerId, isDeal, sortLatest}, fragments = null) => apiCall({ query: GETCUSTOMEREVENTSFORWEBDEAL_QUERY, variables: {identifier, startTime, endTime, customerId, isDeal, sortLatest}, fragments });

const GETMYBOOKEDEVENTS_QUERY = `
  query getMyBookedEvents($startTime: DateTime) {
    getMyBookedEvents(startTime: $startTime)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getMyBookedEventsApiCall = async ({startTime}, fragments = null) => apiCall({ query: GETMYBOOKEDEVENTS_QUERY, variables: {startTime}, fragments });

const GETWAITINGLISTITEMS_QUERY = `
  query getWaitingListItems($sessionId: Int, $classId: Int, $startTime: DateTime) {
    getWaitingListItems(sessionId: $sessionId, classId: $classId, startTime: $startTime)
    {
      subscriptionId
			sessionId
			providerId
			status
			total
			email
      ...fragments
    }
  }`;

export const getWaitingListItemsApiCall = async ({sessionId, classId, startTime}, fragments = null) => apiCall({ query: GETWAITINGLISTITEMS_QUERY, variables: {sessionId, classId, startTime}, fragments });

const GETAVAILABLEBOOKINGS_QUERY = `
  query getAvailableBookings($providerId: Int!, $startTime: DateTime) {
    getAvailableBookings(providerId: $providerId, startTime: $startTime)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getAvailableBookingsApiCall = async ({providerId, startTime}, fragments = null) => apiCall({ query: GETAVAILABLEBOOKINGS_QUERY, variables: {providerId, startTime}, fragments });

const GETMONTHLYAVAILABLEBOOKINGS_QUERY = `
  query getMonthlyAvailableBookings($providerId: Int!, $startTime: DateTime, $entityType: Int) {
    getMonthlyAvailableBookings(providerId: $providerId, startTime: $startTime, entityType: $entityType)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getMonthlyAvailableBookingsApiCall = async ({providerId, startTime, entityType}, fragments = null) => apiCall({ query: GETMONTHLYAVAILABLEBOOKINGS_QUERY, variables: {providerId, startTime, entityType}, fragments });

const GETUNIFIEDBOOKINGS_QUERY = `
  query getUnifiedBookings($providerId: Int, $startTime: DateTime, $entityType: Int) {
    getUnifiedBookings(providerId: $providerId, startTime: $startTime, entityType: $entityType)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getUnifiedBookingsApiCall = async ({providerId, startTime, entityType}, fragments = null) => apiCall({ query: GETUNIFIEDBOOKINGS_QUERY, variables: {providerId, startTime, entityType}, fragments });

const GETUNIFIEDBOOKINGSFORDAY_QUERY = `
  query getUnifiedBookingsForDay($providerId: Int, $day: DateTime, $entityType: Int) {
    getUnifiedBookingsForDay(providerId: $providerId, day: $day, entityType: $entityType)
    {
      id
			subscriptionId
			userId
			providerId
			providerName
			serviceId
			created
			name
			description
			email
			startTime
			endTime
			type
			entityType
			status
			cancelledBy
			code
			duration
			capacity
			totalCapacity
			availableCapacity
			minimumCapacity
			isSessionBought
			classId
			subServiceId
			color
			pricingModel
			price
			paidWithUserMembershipId
			paid
			waitingListPosition
			locationType
			serviceName
			serviceDescription
			note
			presence
			orderId
			displayName
			preparationTime
			collaboratorPercentPrice
			payment
			timezone
			cancelledCounted
			dayEventTotal
			reimbursed
			providerImage
      ...fragments
    }
  }`;

export const getUnifiedBookingsForDayApiCall = async ({providerId, day, entityType}, fragments = null) => apiCall({ query: GETUNIFIEDBOOKINGSFORDAY_QUERY, variables: {providerId, day, entityType}, fragments });

const GETPROVIDERHOMEDETAILS_QUERY = `
  query getProviderHomeDetails {
    getProviderHomeDetails
  }`;

export const getProviderHomeDetailsApiCall = async () => apiCall({ query: GETPROVIDERHOMEDETAILS_QUERY, variables: {}});

const GETUSERSHOMEDETAILS_QUERY = `
  query getUsersHomeDetails {
    getUsersHomeDetails
  }`;

export const getUsersHomeDetailsApiCall = async () => apiCall({ query: GETUSERSHOMEDETAILS_QUERY, variables: {}});

const GETCALENDARHOLIDAYSANDPAUSES_QUERY = `
  query getCalendarHolidaysAndPauses($selectedPeriod: DateTime!, $view: String!) {
    getCalendarHolidaysAndPauses(selectedPeriod: $selectedPeriod, view: $view)
    {
      id
			name
			description
			startTime
			endTime
			entityType
			color
			duration
      ...fragments
    }
  }`;

export const getCalendarHolidaysAndPausesApiCall = async ({selectedPeriod, view}, fragments = null) => apiCall({ query: GETCALENDARHOLIDAYSANDPAUSES_QUERY, variables: {selectedPeriod, view}, fragments });
